import { getCurrencyString, getFullCurrencyString } from './Currency'
import { getPercentString } from './Common'
import i18next from './LocalizedStrings'

export function initTradeInfo(personBank, monkeyBank) {
    tradeInfo.initForDev(personBank, monkeyBank)
    return tradeInfo
}

export function getMonkeyDealsList(data) {

    const buyPosition = [0, data[0].close]
    const sellPosition = [data.length - 1, data[data.length - 1].close]

    const list = [
        {
            type: 'BUY',
            deals: [
                {
                    date: data[0].date,
                    position: buyPosition,
                    type: 'BUY',
                },
                {
                    date: data[data.length - 1].date,
                    position: sellPosition,
                    type: 'SELL',
                }
            ]
        }
    ]

    return list
}

export var tradeInfo = {

    updateMoreData: function (lastData) {
        this.monkeyDealInfo.sellPrice = lastData.close
        this.monkeyDealInfo.sellDate = lastData.date
        this.dateInfo.endDate = lastData.date
    },


    initForDev: function (personBank, monkeyBank) {
        this.initAccount(true, personBank)
        this.initAccount(false, monkeyBank)
        this.personDealInfo = { price: 0, shareCount: 0, state: 'NONE' }
        this.list = []
        this.isMoving = false
    },

    init: function (firstData, lastData, currentData) {

        if (this.isGameData()) {
            this.initMonkeyDealInfo(firstData, lastData, currentData)
        }
        this.dateInfo = { startDate: firstData.date, endDate: lastData.date }
        this.currentPrice = currentData.close

        return this
    },

    initAccount: function (person, bank) {
        const account = {
            person,
            start: { bank, stock: 0 },
            current: { stock: 0, valuation: 0 },
        }

        if (person) this.personAccount = account
        else this.monkeyAccount = account
    },

    deal: function (type, stockData, length, shareCount) {

        const dealInfo = this.personDealInfo

        if (type === 'BUY' && dealInfo.state !== 'NONE') return;
        if (type === 'SHORT' && dealInfo.state !== 'NONE') return;
        if (type === 'SELL' && dealInfo.state !== 'BUY') return;
        if (type === 'EXIT' && dealInfo.state !== 'SHORT') return;

        if (type === 'BUY' || type === 'SHORT') {
            this.buyStock(type, length, stockData, shareCount)
        } else {
            this.sellStock(stockData, length)
        }
    },

    calcCurrentAccount: function (stockData) {

        const currentPrice = stockData.close / this.exchangeValue[this.stockCurrency].value

        if (this.personDealInfo.state === 'SHORT') {
            const dealPrice = this.personDealInfo.price / this.exchangeValue[this.stockCurrency].value
            const shareCount = this.personDealInfo.shareCount
            const dealValuation = dealPrice * shareCount

            const valuation = dealValuation + (dealPrice - currentPrice) * shareCount
            this.personAccount.current.valuation = valuation > 0 ? valuation : 0
        } else {
            this.personAccount.current.valuation = currentPrice * this.personDealInfo.shareCount
        }

        this.monkeyAccount.current.valuation = currentPrice * this.monkeyDealInfo.shareCount

        this.currentPrice = stockData.close
    },

    endInvestment: function (stockData, length) {
        this.sellStock(stockData, length)
        // this.sellStock(stockData, length, this.monkeyAccount, this.monkeyDealInfo)
    },

    sellStock: function (stockData, length, account = this.personAccount, dealInfo = this.personDealInfo) {

        if (account.person) {

            const type = dealInfo.state == 'BUY' ? 'SELL' : 'EXIT'

            const tradingsCount = this.list.length
            if (tradingsCount === 0) return

            let trading = this.list[tradingsCount - 1]
            trading.sellPrice = stockData.close
            trading.endBank = account.start.bank
            trading.endStock = account.current.stock + account.current.valuation

            const deal = {
                type,
                date: stockData.date,
                position: [
                    length,
                    stockData.close
                ]
            }

            trading.deals.push(deal)

            this.personDealInfo = {
                price: 0,
                shareCount: 0,
                state: 'NONE',
            }
        }

        account.current.stock = account.current.stock + account.current.valuation
        account.current.valuation = 0
    },

    buyStock: function (type, length, stockData, shareCount, account = this.personAccount) {

        const currentPrice = stockData.close / this.exchangeValue[this.stockCurrency].value
        const investPrice = currentPrice * shareCount

        // 은행계좌에서 증권계좌로 신규로 입금해야 하는 금액
        const newInvestPrice = investPrice - account.current.stock

        if (newInvestPrice > 0) {
            account.start.bank = account.start.bank - newInvestPrice
            account.start.stock = account.start.stock + newInvestPrice
            account.current.valuation = investPrice
            account.current.stock = 0

        } else {
            account.current.stock = account.current.stock - investPrice
            account.current.valuation = investPrice
        }

        if (account.person) {

            this.personDealInfo = {
                price: stockData.close,
                shareCount,
                state: type,
            }

            let trading = {
                type,
                buyPrice: stockData.close,
                shareCount,
                startBank: account.start.bank,
                startStock: account.current.stock + account.current.valuation,
                deals: [
                    {
                        type,
                        date: stockData.date,
                        position: [
                            length,
                            stockData.close
                        ]
                    }
                ]
            }

            this.list.push(trading)
        }
    },

    initMonkeyDealInfo: function (firstData, lastData, currentData) {

        const buyPrice = firstData.close / this.exchangeValue[this.stockCurrency].value
        const currentPrice = currentData.close / this.exchangeValue[this.stockCurrency].value
        const shareCount = Math.floor(this.monkeyAccount.start.bank / buyPrice);

        this.buyStock('BUY', 0, firstData, shareCount, this.monkeyAccount)

        this.monkeyDealInfo = {
            buyPrice: firstData.close,
            sellPrice: lastData.close,
            buyDate: firstData.date,
            sellDate: lastData.date,
            shareCount,
        }

        this.monkeyAccount.current.valuation = shareCount * currentPrice
    },

    isViewerData: function () {
        return this.view_type == 'VIEW'
    },

    isGameData: function () {
        return this.view_type == 'GAME'
    },

    getPersonYield() {
        const currentStock = this.personAccount.current.stock + this.personAccount.current.valuation
        const _yield = currentStock / this.personAccount.start.stock - 1

        return isNaN(_yield) ? 0 : _yield
    },

    getPersonInvestment() {
        return this.personAccount.start.stock
    },

    getPersonValuation() {
        return this.personAccount.current.stock + this.personAccount.current.valuation
    },

    getPersonProfit() {
        return this.getPersonValuation() - this.personAccount.start.stock
    },

    getPersonStartAsset: function () {
        return this.personAccount.start.bank + this.personAccount.start.stock
    },

    getPersonEndAsset() {

        const insurance = this.personAccount.insurance ? this.personAccount.insurance.value : 0
        return this.personAccount.start.bank + this.getPersonValuation() + insurance
    },


    getPersonBankCurrencyString(currency) {
        // return getCurrencyString(this.personAccount.start.bank, currency)
    },

    getPersonCurrentStockCurrencyString(currency) {
        const currentStock = this.personAccount.current.stock + this.personAccount.current.valuation
        // return getCurrencyString(currentStock, currency)
    },

    getMonkeyStartAsset: function () {
        return this.monkeyAccount.start.bank + this.monkeyAccount.start.stock
    },

    getMonkeyEndAsset() {
        return this.monkeyAccount.start.bank + this.getMonkeyValuation()
    },

    getMonkeyInvestment() {
        return this.monkeyAccount.start.stock
    },

    getMonkeyYield() {
        const _yield = this.getMonkeyValuation() / this.monkeyAccount.start.stock - 1
        return isNaN(_yield) ? 0 : _yield
    },

    getMonkeyValuation() {
        return this.monkeyAccount.current.stock + this.monkeyAccount.current.valuation
    },

    getMonkeyProfit() {
        return this.getMonkeyValuation() - this.monkeyAccount.start.stock
    },


    sellMonkeyStock() {
        this.monkeyAccount.current.stock = this.monkeyAccount.current.stock + this.monkeyAccount.current.valuation
        this.monkeyAccount.current.valuation = 0
    },

    getPersonDealCount: function () {
        let buyCount = 0;
        let shortCount = 0;

        for (var idx in this.list) {
            const deal = this.list[idx];
            if (deal.type === 'BUY') {
                buyCount++;
            } else {
                shortCount++;
            }
        }

        return { buyCount, shortCount }
    },

    getStartDate: function () {
        return this.dateInfo ? this.dateInfo.startDate : this.monkeyDealInfo.buyDate
    },

    getEndDate: function () {
        return this.dateInfo ? this.dateInfo.endDate : this.monkeyDealInfo.sellDate
    },

    getInvestment: function (currency) {

        const meAccount = this.personAccount.start.stock
        const monkeyAccount = this.monkeyAccount.start.stock

        return {
            short: {
                me: getCurrencyString(meAccount == 0 || meAccount == undefined ? 0 : meAccount, currency),
                monkey: getCurrencyString(monkeyAccount, currency),
            },
            full: {
                me: getFullCurrencyString(meAccount == 0 || meAccount == undefined ? 0 : meAccount, currency),
                monkey: getFullCurrencyString(monkeyAccount, currency)
            }
        }
    },

    getValuation: function (currency) {
        return {

            short: {
                me: getCurrencyString(this.getPersonValuation(), currency),
                monkey: getCurrencyString(this.getMonkeyValuation(), currency),
            },
            full: {
                me: getFullCurrencyString(this.getPersonValuation(), currency),
                monkey: getFullCurrencyString(this.getMonkeyValuation(), currency)
            }
        }
    },

    getProfit: function (currency) {
        return {
            short: {
                me: getCurrencyString(this.getPersonProfit(), currency),
                monkey: getCurrencyString(this.getMonkeyProfit(), currency),
            },
            full: {
                me: getFullCurrencyString(this.getPersonProfit(), currency),
                monkey: getFullCurrencyString(this.getMonkeyProfit(), currency),
            }
        }
    },

    getYield: function () {

        return {
            me: getPercentString(this.getPersonYield(), 1),
            monkey: getPercentString(this.getMonkeyYield(), 1),
        }
    },

    getNumberOfTransaction: function () {

        const personDealCount = this.getPersonDealCount()
        const buyCount = personDealCount.buyCount
        const shortCount = personDealCount.shortCount

        return {
            me: {
                value: buyCount + shortCount,
                footer: i18next.t('dealPopup.buy') + ' ' + buyCount + '\u000A' + i18next.t('dealPopup.short') + ' ' + shortCount,
            },
            monkey: {
                value: 1,
                footer: i18next.t('dealPopup.buy') + ' 1\u000A' + i18next.t('dealPopup.short') + ' 0'
            }
        }
    },



    getStartAsset: function (currency) {

        return {
            short: {
                me: getCurrencyString(this.getPersonStartAsset(), currency),
                monkey: getCurrencyString(this.getMonkeyStartAsset(), currency),
            },
            full: {
                me: getFullCurrencyString(this.getPersonStartAsset(), currency),
                monkey: getFullCurrencyString(this.getMonkeyStartAsset(), currency)
            }
        }
    },


    getEndAsset: function (currency) {

        return {
            short: {
                me: getCurrencyString(this.getPersonEndAsset(), currency),
                monkey: getCurrencyString(this.getMonkeyEndAsset(), currency),
            },
            full: {
                me: getFullCurrencyString(this.getPersonEndAsset(), currency),
                monkey: getFullCurrencyString(this.getMonkeyEndAsset(), currency)
            }
        }
    },

    isRevenue: function () {
        // -1 이면 손실
        // 0이면 본전
        // 1이면 수익

        let me = this.personAccount.start.stock == this.personAccount.current.stock + this.personAccount.current.valuation ? 0 :
            this.personAccount.start.stock > this.personAccount.current.stock + this.personAccount.current.valuation ? -1 : 1;
        let monkey = this.monkeyAccount.start.stock == this.monkeyAccount.current.stock + this.monkeyAccount.current.valuation ? 0 :
            this.monkeyAccount.start.stock > this.monkeyAccount.current.stock + this.monkeyAccount.current.valuation ? -1 : 1;

        return {
            me, monkey
        }
    },

    getMaxSharesCount: function (stockData) {
        const asset = this.getPersonEndAsset()
        const buyPrice = stockData.close / this.exchangeValue[this.stockCurrency].value
        const count = Math.floor(asset / buyPrice)
        return count
    }
}